import { createAction } from '@reduxjs/toolkit';

import { SET_LOCALE, type Locale } from './types';

export const setLocale = createAction<Locale, typeof SET_LOCALE>(SET_LOCALE);
